import { call, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";
import * as actionTypes from "../ActionTypes";

import {
  saveCampusVideoSuccess,
  saveCampusVideoFailure,
  updateCampusVideoSuccess,
  updateCampusVideoFailure,
  deleteCampusVideoSuccess,
  deleteCampusVideoFailure,
  readCampusVideoSuccess,
  readCampusVideoFailure,
} from "./CampusVideoActions";

import {
  saveCampusVideo,
  updateCampusVideo,
  deleteCampusVideo,
  readCampusVideos,
} from "./CampusVideoAPI";

// SAVE
function* saveCampusVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(saveCampusVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(saveCampusVideoSuccess(res.data));
      toast.success(res.message || "Campus video saved!");
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (e) {
    yield put(saveCampusVideoFailure(e.message));
    toast.error(e.message);
    action.callback?.({ type: 0, error: e.message });
  }
}

// UPDATE
function* updateCampusVideoSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
    const res = yield call(updateCampusVideo, apiPayloadRequest);

    if (res?.type === 1) {
      yield put(updateCampusVideoSuccess(res.data));
      toast.success(res.message || "Campus video updated!");
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (e) {
    yield put(updateCampusVideoFailure(e.message));
    toast.error(e.message);
    action.callback?.({ type: 0, error: e.message });
  }
}

// DELETE
function* deleteCampusVideoSaga(action) {
  try {
    const res = yield call(deleteCampusVideo, action.payload);

    if (res?.type === 1) {
      yield put(deleteCampusVideoSuccess(action.payload));
      toast.success(res.message || "Campus video deleted!");
      action.callback?.({ type: 1 });
    } else throw new Error(res.error);
  } catch (e) {
    yield put(deleteCampusVideoFailure(e.message));
    toast.error(e.message);
    action.callback?.({ type: 0, error: e.message });
  }
}

// READ
function* readCampusVideosSaga(action) {
  try {
    const res = yield call(readCampusVideos, action.payload);

    if (res?.type === 1) {
      yield put(readCampusVideoSuccess(res.data));
      action.callback?.({ type: 1, data: res.data });
    } else throw new Error(res.error);
  } catch (e) {
    yield put(readCampusVideoFailure(e.message));
    action.callback?.({ type: 0, error: e.message });
  }
}

export default function* campusVideoWatcherSaga() {
  yield takeLatest(actionTypes.SAVE_CAMPUS_VIDEO_REQUEST, saveCampusVideoSaga);
  yield takeLatest(actionTypes.UPDATE_CAMPUS_VIDEO_REQUEST, updateCampusVideoSaga);
  yield takeLatest(actionTypes.DELETE_CAMPUS_VIDEO_REQUEST, deleteCampusVideoSaga);
  yield takeLatest(actionTypes.READ_CAMPUS_VIDEO_REQUEST, readCampusVideosSaga);
}
